<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M3 12c0 .66.292 1.252.75 1.665V15c0 .412.338.75.75.75h.75c.412 0 .75-.338.75-.75v-.75h6V15c0 .412.338.75.75.75h.75c.412 0 .75-.338.75-.75v-1.335A2.24 2.24 0 0 0 15 12V4.5c0-2.625-2.685-3-6-3s-6 .375-6 3V12Zm2.625.75A1.123 1.123 0 0 1 4.5 11.625c0-.623.503-1.125 1.125-1.125s1.125.502 1.125 1.125-.503 1.125-1.125 1.125Zm6.75 0a1.123 1.123 0 0 1-1.125-1.125c0-.623.502-1.125 1.125-1.125s1.125.502 1.125 1.125-.502 1.125-1.125 1.125Zm1.125-4.5h-9V4.5h9v3.75Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
